import React from "react";
import { Col, Container, Button, Form, InputGroup } from "react-bootstrap";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Nav from "../../../Component/Layouts/Nav";
import { Formik } from "formik";
import * as Yup from "yup";
import { ConfigService } from "../../../Services/systemConfigService";
import { UserService } from "../../../Services/userService";
import { AuthContext } from "../../../Context/AuthContext";
import { useHistory } from "react-router-dom";
import { useLoadingMessage } from "../../../Component/useLoadingMessage";
import { PageBody } from "../../../Component/Loader";
import { phoneRegExp } from "../../../Util/Constants/constant";

const Styles = styled.div``;

export const Create_user = () => {
  const { alert } = React.useContext(AuthContext);
  const [roles, setRoles] = React.useState([]);
  const history = useHistory();
  const { isLoading, message, updateLoader } = useLoadingMessage();

  const getroles = async () => {
    updateLoader(true, "Loading");
    const response = await ConfigService.getroles();
    setRoles(response.data.data);
    updateLoader(false);
  };

  React.useEffect(() => {
    getroles();
  }, []);
  return (
    <PageBody isLoading={isLoading} message={message}>
      <Styles>
        <Nav />

        <Container className="mt-5">
          <h5 className="form-h mb-3">
            {" "}
            <strong>Create New User</strong>{" "}
          </h5>

          <Formik
            initialValues={{
              first_name: "",
              last_name: "",
              role_id: "",
              email: "",
              phonenumber: "",
            }}
            validationSchema={Yup.object({
              first_name: Yup.string()
                .trim()
                .required("first name is a required field"),

              last_name: Yup.string()
                .trim()
                .required("last name is a required field"),

              role_id: Yup.number()
                .min(1, "please select from the options")
                .required("role is a required field"),

              phonenumber: Yup.string()
                .required("phone number is a required field")
                .max(14, "phone number must be 14 digits maximum")
                .min(10, "phone number must be 11 digits minimum")
                .matches(phoneRegExp, "Phone number is not valid"),

              email: Yup.string().email("Invalid email address").required(),
            })}
            onSubmit={async (values, { setSubmitting }) => {
              const response = await UserService.createuser(values);
              if (response.status === 200) {
                alert.success(response.data.message);
                setSubmitting(false);
                history.push("/users");
              } else {
                if (response.response.data.data.email)
                  alert.error(response.response.data.data.email);
                if (response.response.data.data.phonenumber)
                  alert.error(response.response.data.data.phonenumber);
              }
            }}
          >
            {({
              isSubmitting,
              handleSubmit,
              handleChange,
              values,
              touched,
              errors,
            }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Form.Row className="justify-content-md-center">
                  <Form.Group as={Col} md={5}>
                    <Form.Label>
                      First name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="first_name"
                      value={values.first_name}
                      onChange={handleChange}
                    />
                    {touched.first_name && errors.first_name ? (
                      <div className="text-danger">{errors.first_name}</div>
                    ) : null}
                  </Form.Group>

                  <Form.Group as={Col} md={5}>
                    <Form.Label>
                      Last name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="last_name"
                      value={values.last_name}
                      onChange={handleChange}
                    />
                    {touched.last_name && errors.last_name ? (
                      <div className="text-danger">{errors.last_name}</div>
                    ) : null}
                  </Form.Group>
                </Form.Row>
                <Form.Row className="justify-content-md-center">
                  <Form.Group as={Col} md={5}>
                    <Form.Label>
                      Role <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="select"
                      name="role_id"
                      value={values.role_id}
                      onChange={handleChange}
                    >
                      <option value="0">Choose...</option>
                      {roles.map(
                        (role, i) =>
                          role.status > 0 && (
                            <option value={role.id} key={i}>
                              {role.name}
                            </option>
                          )
                      )}
                    </Form.Control>
                    {touched.role_id && errors.role_id ? (
                      <div className="text-danger">{errors.role_id}</div>
                    ) : null}
                  </Form.Group>

                  {/* <Form.Group as={Col} md={5}>
                    <Form.Label>Gender</Form.Label>
                    <Form.Control
                      as="select"
                      name="gender"
                      value={values.gender}
                      onChange={handleChange}
                    >
                      <option value={0}>Choose...</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </Form.Control>
                  </Form.Group> */}
                  <Form.Group as={Col} md={5}>
                    <Form.Label>
                      Phone number <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup className="mb-2">
                      {/* <InputGroup.Prepend>
                                                    <InputGroup.Text><strong>+</strong></InputGroup.Text>
                                                </InputGroup.Prepend> */}
                      <Form.Control
                        name="phonenumber"
                        value={values.phonenumber}
                        onChange={handleChange}
                      />
                      {touched.phonenumber && errors.phonenumber ? (
                        <div className="text-danger">{errors.phonenumber}</div>
                      ) : null}
                    </InputGroup>
                  </Form.Group>
                </Form.Row>

                <Form.Row className="justify-content-md-center">
                  <Form.Group as={Col} md={10}>
                    <Form.Label>
                      Email <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                    />
                    {touched.email && errors.email ? (
                      <div className="text-danger">{errors.email}</div>
                    ) : null}
                  </Form.Group>
                </Form.Row>

                <Form.Group>
                  <div className="mt-3 text-center">
                    <Link to="/users">
                      <Button className="btn-cancel m-3 shadow">Cancel</Button>
                    </Link>
                    <Button
                      type="submit"
                      className="btn-save m-3 shadow"
                      disabled={isSubmitting}
                    >
                      Save{" "}
                      {isSubmitting ? (
                        <span
                          id="login_spinner"
                          className="fa fa-spin fa-spinner"
                        ></span>
                      ) : null}
                    </Button>
                  </div>
                </Form.Group>
              </Form>
            )}
          </Formik>
        </Container>
      </Styles>
    </PageBody>
  );
};
